import Papa from "papaparse";

/**
 * Handler for generic/standard CSV file format
 */
export class GenericHandler {
  
  /**
   * Process generic CSV data - simple row filtering
   */
  static processGenericData(csvDataArray: string[]): string[] {
    const csvRowStrArray: string[] = [];
    let isStringFound: boolean = false;

    const studentIDColumn: string[] = [
      'ID',
      'Student ID',
      'Student ID#',
      'student_id',
      'StudentId',
      'Student_ID',
      'first_name',
      'last_name',
      'First',
      'Last'
    ];

    for (let i = 0; i < csvDataArray.length; i++) {
      const csvRowStr = csvDataArray[i];
      
      // Skip blank rows until header found
      if (!studentIDColumn.some((sid) => csvRowStr.includes(sid)) && !isStringFound) {
        continue;
      }
      
      isStringFound = true;
      const csvRowSubStringArray = csvRowStr.split(',');
      const isArrayBlank = csvRowSubStringArray.every((data) => data.trim() === '');

      if (!isArrayBlank) {
        csvRowStrArray.push(csvRowStr);
      }
    }

    return csvRowStrArray;
  }

  /**
   * Parse generic CSV data using Papa Parse
   */
  static parseGenericData(
    csvData: string,
    updateDataCallback: (result: any, file: File) => void
  ): void {
    Papa.parse(csvData, {
      complete: updateDataCallback,
      header: true,
      dynamicTyping: true,
      trimHeaders: true,
      skipEmptyLines: true,
      transform(value: string, field: string | number): any {
        return value.trim();
      },
      transformHeader(header: string): any {
        return header.trim();
      },
    });
  }
}
